import React, { useEffect } from 'react';
import CustomAddPage from 'components/custom-pages/CustomAddPage';

const Add = ({ data, handleClick }) => {
  const [initialValues, setInitialValues] = React.useState({
    name: data?.name || '',
    retreadNSD: data?.retreadNSD || '',
  });

  const inputFields = [
    {
      name: 'name',
      label: 'Size Name',
      type: 'text',
      required: true,
    },
    {
      name: 'retreadNSD',
      label: 'Retread NSD',
      type: 'number',
      required: true,
    },
  ];

  return (
    <CustomAddPage
      pageTitle={data ? 'Update Size Master' : 'Add Size Master'}
      url={'size-master'}
      action={!data ? 'create' : 'update'}
      updateId={data?._id}
      queryKey="size-master"
      inputFields={inputFields}
      data={initialValues}
      setData={setInitialValues}
      handleClick={handleClick}
    />
  );
};

export default Add;
 